import { useState, useEffect, useReducer, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
// import DatePicker from "react-datepicker";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,

  InputLabel,
  MenuItem,
  TextField,
  Select,
  Skeleton,
} from "@mui/material";

import { ErrorMessage, Field, Formik, Form, useFormikContext } from "formik";
import * as Yup from "yup";

// Project imports
import {
  editPcaData,
  editPcaDataReset,
  getAllRegisteredCmPca,
} from "../../Actions";

import TextFieldWrapper from "../FormikWrappers/TextField";
import SingleSelectWrapper from "../FormikWrappers/SingleSelect";
import ButtonWrapper from "../FormikWrappers/Button";

const UpdateFormValues = ({ cmDetails }) => {
  const { setValues } = useFormikContext();

  useEffect(() => {
    if (Object?.keys(cmDetails)?.length > 0) {
      setValues(cmDetails);
    }
  }, [cmDetails]);

  return null;
};

const initial_state = {
  cmName: "",
  cmStateCode: "",
  ppa: "",
  skillId: "",
  trainigCost: "",
  trainingCenterName: "",
  trainingStartDate: "2018-07-22",
  trainingEndDate: new Date(),
};

const NON_EMPTY = "This is a required field";

const validationSchema = Yup.object().shape({
  cmName: Yup.string().required(NON_EMPTY),
  cmStateCode: Yup.string().required(NON_EMPTY),
  ppa: Yup.string().required(NON_EMPTY),
  skillId: Yup.number().required(NON_EMPTY),
  trainigCost: Yup.number()
    .typeError("Only numbers are allowed")
    .required(NON_EMPTY),
  trainingCenterName: Yup.string().required(NON_EMPTY),
  // trainingStartDate: new Date(),
  // trainingEndDate: new Date(),
});

function localReducer(state, action) {
  switch (action.type) {
    case "fetched_single_cm_details":
      return {
        ...state,
        ...action.body,
      };

    case "changedSkill":
      return {
        ...state,
        skillId: action.body,
      };

    case "changedTrainingCost":
      return {
        ...state,
        trainigCost: action.body,
      };

    case "changedTrainingCenterName":
      return {
        ...state,
        trainingCenterName: action.body,
      };

    case "changedTrainingStartDate":
      return {
        ...state,
        trainingStartDate: action.body,
      };

    case "changedTrainingEndDate":
      return {
        ...state,
        trainingEndDate: action.body,
      };

    case "clearedAllFields":
      return {
        ...state,
        cmName: "",
        cmStateCode: "",
        ppa: "",
        skillId: "",
        trainigCost: "",
        trainingCenterName: "",
        trainingStartDate: new Date(),
        trainingEndDate: new Date(),
      };

    default:
      return state;
  }
}

const PCAEditDialog = ({ isOpen, handleClose }) => {
  const [localState, localDispatch] = useReducer(localReducer, initial_state);
  const globalDispatch = useDispatch();

  const pcaState = (state) => state.postCampActivityReducer;
  const {
    singleCmData,
    allActiveSkills,
    savingPcaEdits,
    fetchingSingleCmData,
    pcaEditsSavedSuccessfully,
  } = useSelector(pcaState);

  function handleCloseMiddleWare() {
    handleClose();
    globalDispatch(editPcaDataReset());
    localDispatch({ type: "clearedAllFields" });
  }

  function handleSaveEdits(values) {
    const {
      skillId,
      trainigCost,
      trainingCenterName,
      trainingStartDate,
      trainingEndDate,
    } = values;

    const payload = {
      id: singleCmData.id,
      body: {
        skillId,
        trainigCost,
        trainingCenterName,
        trainingStartDate,
        trainingEndDate,
      },
    };
    globalDispatch(editPcaData(payload));
  }

  useEffect(() => {
    // update local store with API data
    if (Object.keys(singleCmData).length > 0) {
      localDispatch({
        type: "fetched_single_cm_details",
        body: singleCmData,
      });
    }
  }, [singleCmData]);

  useEffect(() => {
    if (pcaEditsSavedSuccessfully && !savingPcaEdits) {
      handleCloseMiddleWare();
      globalDispatch(getAllRegisteredCmPca());
    }
  }, [pcaEditsSavedSuccessfully]);

  const markup = [
    {
      title: "Name",
      type: "TextField",
      name: "cmName",
      editable: false,
    },
    {
      title: "State Code",
      type: "TextField",
      name: "cmStateCode",
      editable: false,
    },
    {
      title: "PPA",
      type: "TextField",
      name: "ppa",
      editable: false,
    },
    {
      title: "Name of Vocational Training Center",
      type: "TextField",
      name: "trainingCenterName",
      editable: true,
    },
    {
      label: "Skill to be Acquired",
      name: "skillId",
      type: "SingleSelect",
      options: allActiveSkills,
    },
    {
      title: "Cost of Training",
      name: "trainigCost",
      type: "TextField",
      editable: true,
    },
    {
      title: "Training Start Date",
      type: "Date",
      value: localState.trainingStartDate,
      props: {
        startDate: localState.trainingStartDate,
        endDate: localState.trainingEndDate,
        minDate: new Date(),
      },
      // onChange: (newDate) =>
      //   localDispatch({
      //     type: "changedTrainingStartDate",
      //     body: newDate,
      //   }),
    },
    {
      title: "Training End Date",
      type: "Date",
      value: localState.trainingEndDate,
      props: {
        startDate: localState.trainingStartDate,
        endDate: localState.trainingEndDate,
        minDate: localState.trainingStartDate,
      },
      // onChange: (newDate) =>
      //   localDispatch({
      //     type: "changedTrainingEndDate",
      //     body: newDate,
      //   }),
    },
  ];

  return (
    <Formik
      initialValues={initial_state}
      validationSchema={validationSchema}
      onSubmit={handleSaveEdits}
    >
      <Form>
        <Dialog
          open={isOpen}
          onClose={handleCloseMiddleWare}
          fullWidth={true}
          maxWidth={"xs"}
        >
          <DialogTitle>Edit Post Camp Activity</DialogTitle>

          <DialogContent sx={{ paddingTop: "1rem", borderRadius: "7px" }}>
            {markup.map((field, index) => {
              if (fetchingSingleCmData) {
                return (
                  <Skeleton key={index} animation={"wave"} height={'4rem'} width={'22rem'} />
                )
              } else if (field.type === "TextField") {
                return (
                  <Fragment key={index}>
                    <TextFieldWrapper
                      label={field.title}
                      name={field.name}
                      InputProps={{
                        readOnly: !field.editable,
                      }}
                    />
                  </Fragment>
                );
              } else if (field.type === "SingleSelect") {
                return (
                  <Fragment key={index}>
                    <SingleSelectWrapper
                      name={field.name}
                      label={field.label}
                      options={field.options}
                    />
                  </Fragment>
                );
              } 
              // else if (field.type === "Date") {
              //   return (
              //     <Grid
              //       key={index}
              //       item
              //       xs
              //       container
              //       sx={{
              //         display: "flex",
              //         flexDirection: "row",
              //       }}
              //     >
              //       <input type="date" value={field.value} />
                    
              //     </Grid>
              //   );
              // }
            })}
          </DialogContent>

          <DialogActions>
            <Button
              variant="outlined"
              disabled={savingPcaEdits}
              onClick={handleCloseMiddleWare}
            >
              Cancel
            </Button>

            <ButtonWrapper disabled={savingPcaEdits}>
              {savingPcaEdits ? (
                <>
                  <CircularProgress sx={{ color: "white" }} size={12} />
                </>
              ) : (
                <>Save</>
              )}
            </ButtonWrapper>
          </DialogActions>
        </Dialog>
        <UpdateFormValues cmDetails={singleCmData} />
      </Form>
    </Formik>
  );
};

export default PCAEditDialog;
